import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';

import { GlobalService } from './global.service';
import { Subject } from 'rxjs/Subject';
import { ssApiService } from './ss-api.service';
import { AdminBrowseLogItemArray, AdminBrowseLogItem } from '../models/ss-api/responses/admin.browse.logs.response';

@Injectable()
export class AdminHistoryService implements OnDestroy {

    public onHistoryLoaded = new Subject<AdminBrowseLogItemArray>();
    public onHistoryAdded = new Subject<AdminBrowseLogItem>();
    public onHistoryChanged = new Subject<AdminBrowseLogItemArray>();

    public History = new AdminBrowseLogItemArray();

    // subscriptions
    private SubHistoryChanged: Subscription;

    constructor(private api: ssApiService, private gb: GlobalService) {
        this.SubscribeToEvents();
        this.Refresh();
    }


    ngOnDestroy(): void {
        this.SubHistoryChanged.unsubscribe();
    }

    SubscribeToEvents() {

        this.SubHistoryChanged = this.api.onHistoryAdminBrowseLogs.subscribe(response => {

            // console.log("Admin History Intercepted", response);

            if (!response.Result)
                return;

            this.History = response.Data;
            this.onHistoryChanged.next(response.Data);

        })

    }

    Refresh() {
        let subscription = this.api.AdminBrowseLogs(this.gb.AdminHistoryMaxResults).subscribe(response => { subscription.unsubscribe() });
    }

    AddLocal(item: AdminBrowseLogItem) {

        this.History.push(item);
        this.onHistoryAdded.next(item);
        this.onHistoryChanged.next(this.History);
    }
}
